import React from 'react';
import { colors } from '@guryou/colors';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Small rounded status/category badge (the "pill" look shared by AI Studio 2 and
// the training mockups). Colors come from @guryou/colors tokens at the call site.
// `tone` picks the geometry: 'badge' = 20px-radius lifecycle badge, 'tag' =
// 5px-radius compact category tag.

const PillBase = ({
  bg,
  fg,
  tone,
  ...rest
}) => /*#__PURE__*/React.createElement("span", rest);
const BadgePill = styled(PillBase)`
  display: inline-block;
  padding: ${p => p.tone === 'tag' ? '2px 8px' : '2px 9px'};
  border-radius: ${p => p.tone === 'tag' ? 5 : 20}px;
  font-size: ${p => p.tone === 'tag' ? 11 : 11.5}px;
  font-weight: 600;
  background: ${p => p.bg || colors.riminiLight};
  color: ${p => p.fg || colors.rimini};
  white-space: nowrap;
`;
PillBase.propTypes = {
  bg: PropTypes.string,
  fg: PropTypes.string,
  tone: PropTypes.oneOf(['badge', 'tag'])
};
export { BadgePill };